import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureGetTopics, successGetTopics } from "./TopicSelectionSlice";

// API call to fetch subjects
const GetTopicsApi = () => {
    return api.get("/api/schedule-class/subjects");
};

// Saga to handle fetching subjects
export function* GetTopicsCall() {
    try {
        const response: AxiosResponse = yield call(GetTopicsApi);
        yield put(successGetTopics(response.data));
    } catch (error: any) {
        yield put(failureGetTopics(error.response?.data || error.message));
    }
}
